// extracted by mini-css-extract-plugin
export default {"headerContainer":"PageHeaderName_headerContainer__+QIo3","headerBox":"PageHeaderName_headerBox__tzg+p"};